/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metric_Avg_Tx_Fee_Name_ShortInputs */



/**
* | output |
* | --- |
* | "Average Tx Fee" |
*
* @param {Metric_Avg_Tx_Fee_Name_ShortInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metric_avg_tx_fee_name_short = /** @type {((inputs?: Metric_Avg_Tx_Fee_Name_ShortInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metric_Avg_Tx_Fee_Name_ShortInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Average Tx Fee")
});